import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CHAT_MESSAGES: { role: 'user' | 'bot'; text: string; delay: number }[] = [
  { role: 'user', text: 'היי, יש לך תור פנוי מחר לגבות?', delay: 0 },
  { role: 'bot', text: 'היי! כן, יש לי כמה שעות פנויות מחר. מתי מתאים לך?', delay: 2000 },
  { role: 'user', text: 'שעות הבוקר', delay: 3500 },
  { role: 'bot', text: 'יש לי ב 09:45 או ב 10:30, מתי תעדיפי?', delay: 5500},
  { role: 'user', text: '10:30 יהיה מעולה', delay: 7500},
  { role: 'bot', text: 'בשמחה, רק תאשרי לי את הפרטים, מחר ב10:30 תור לגבות, המחיר 150 ש״ח', delay: 9000},
  { role: 'user', text: 'מאשרת, תודה', delay: 11000},
  { role: 'bot', text: 'מהמם, קבענו, מחכה לך!📅', delay: 12000 },
];

function ChatBubble({ role, text }: { role: 'user' | 'bot'; text: string }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.35, ease: 'easeOut' }}
      className={`flex ${role === 'user' ? 'justify-end' : 'justify-start'}`}
    >
      <div
        className={`max-w-[85%] px-3 py-2 rounded-2xl text-sm ${
          role === 'user'
            ? 'bg-[#dcf8c6] text-gray-800 rounded-br-md'
            : 'bg-white text-gray-800 shadow-sm border border-gray-100 rounded-bl-md'
        }`}
      >
        {text}
      </div>
    </motion.div>
  );
}

export default function PhoneMockup() {
  const [visibleCount, setVisibleCount] = useState(0);

  useEffect(() => {
    const timers = CHAT_MESSAGES.map((msg, i) =>
      setTimeout(() => setVisibleCount((c) => Math.max(c, i + 1)), msg.delay)
    );
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div className="relative flex justify-center items-center">
      {/* Floating badges */}
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 2.5 }}
        className="absolute -bottom-2 -left-2 lg:-left-6 bg-white/90 backdrop-blur-sm shadow-lg rounded-xl px-4 py-2 border border-white/40 z-10 animate-beta-float-delay"
      >
        <span className="text-sm font-medium text-gray-800">לקוחה חדשה! 🎉</span>
      </motion.div>

      {/* iPhone frame - scales down on narrow screens */}
      <div className="relative w-[260px] min-w-0 max-w-full sm:w-[300px] lg:w-[320px]">
        <div className="relative bg-[#1a1a1a] rounded-[2.5rem] p-2.5 sm:p-3 shadow-2xl shadow-gray-400/25">
          {/* Notch */}
          <div className="absolute top-2.5 left-1/2 -translate-x-1/2 w-24 h-5 sm:w-28 sm:h-6 bg-black rounded-b-xl z-20" />
          {/* Screen */}
          <div className="relative bg-[#e5ddd5] rounded-[2rem] overflow-hidden min-h-[480px] sm:min-h-[520px]">
            {/* WhatsApp-style header */}
            <div className="bg-[#075e54] px-4 py-3 pt-8 flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-white text-xs font-medium">
                בוט
              </div>
              <div className="flex-1">
                <p className="text-white font-medium text-sm">בוט התורים</p>
                <p className="text-white/80 text-xs">מחובר</p>
              </div>
            </div>
            {/* Chat area */}
            <div className="p-3 space-y-3 min-h-[360px] overflow-hidden">
              <AnimatePresence mode="popLayout">
                {CHAT_MESSAGES.slice(0, visibleCount).map((msg, i) => (
                  <ChatBubble key={i} role={msg.role} text={msg.text} />
                ))}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
